import { Col } from '@opendoor/atoms/box';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import type { EntryComponent } from 'cms/entries/entries';
import type { ILpComponentFactBar, ILpElementFact } from 'declarations/contentful';

import Container from './shared/Container';

const FactItem = ({ fact, analyticsId }: { fact: ILpElementFact; analyticsId?: string }) => (
  <Col className="min-w-35 flex-1 gap-1">
    {/* Atoms has no label token below 14px, so text-xs (12px) is the closest step to
        Bricks $labelXsmall (11px) without hardcoding a raw size. */}
    <Text as="p" className="text-xs font-medium uppercase text-od-content-tertiary">
      {fact.fields.label}
    </Text>
    {fact.fields.valueLink ? (
      // Atoms Link underlines by default; Bricks Link variant="primary" did not, so
      // !no-underline restores the original look.
      <Link
        href={fact.fields.valueLink}
        analyticsName={`cosmos-landing-page-v2-fact-bar-${analyticsId ?? ''}-${fact.sys?.id ?? ''}`}
        className="text-subheader-sm font-medium !no-underline"
      >
        {fact.fields.value}
      </Link>
    ) : (
      <Text as="p" className="text-subheader-sm font-medium text-od-content-primary">
        {fact.fields.value}
      </Text>
    )}
  </Col>
);

const renderFactBar = (entry: ILpComponentFactBar) => {
  const { items, eyebrow, analyticsId } = entry.fields;
  if (!items?.length) {
    return null;
  }

  return (
    <Container noSectionSpacing backgroundColor="$backgroundTertiary" className="py-8">
      <Col className="gap-3">
        {eyebrow && (
          <Text as="p" className="text-body-md font-medium text-od-content-tertiary">
            {eyebrow}
          </Text>
        )}
        <Col className="gap-6 md:flex-row md:flex-wrap">
          {items.map((fact, i) => (
            <FactItem key={fact.sys?.id ?? i} fact={fact} analyticsId={analyticsId} />
          ))}
        </Col>
      </Col>
    </Container>
  );
};

const FactBar: EntryComponent<ILpComponentFactBar> = {
  render: renderFactBar,
};

export default FactBar;
